export const LANGUAGE_SELECTOR = 'language-selector';
